import HealthRecordList from './HealthRecordList';

export default HealthRecordList;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordList/index.js